import { cn } from "@omni/utils/styles";
import { ComponentType } from "react";

import { useSearchComponentStateSelector } from "@/redux/modules/value/search/search.selectors";
import { AlgoliaSearchHit } from "@/services/algolia/types/search.types";
import { ContentPageAlgoliaModel } from "@/types/service/algolia/contentPage.algolia.model";
import { ResultListHit } from "@/utils/search/types/internal/resultListHit";
import { SearchComponent } from "@/utils/search/types/searchComponent";

import {
    ResultList,
    ResultListHitComponentProps
} from "../../../../../resultList/resultList.container";

type Props = {
    className?: string;
    hitComponent: ComponentType<
        ResultListHitComponentProps<ContentPageAlgoliaModel>
    >;
};

const Base = ({ className, hitComponent }: Props) => {
    const resultListComponentState = useSearchComponentStateSelector(
        SearchComponent.CONTENT_RESULT_LIST
    );

    const hits = resultListComponentState?.hits as
        | Array<ResultListHit<AlgoliaSearchHit<ContentPageAlgoliaModel>>>
        | undefined;

    if (!hits?.length) return null;

    return (
        <ResultList
            className={cn(className)}
            component={SearchComponent.CONTENT_RESULT_LIST}
            hits={hits}
            keyExtractor={(hit) => hit.objectID}
            HitComponent={hitComponent}
        />
    );
};

export { Base };
